import { IPagedListResponse } from "../global/pagedListResponse"
import {UsuarioResponse} from "./usuarioResponse"
export const USUARIOS_EMPRESA_GET = 'USUARIOS_EMPRESA_GET'

export interface UsuarioState {
    UsuariosEmpresa: IPagedListResponse<UsuarioResponse> | undefined,
}

export interface UsuarioEmpresaAction {
    type: typeof USUARIOS_EMPRESA_GET,
    payload: IPagedListResponse<UsuarioResponse>
}

export type UsuarioActionTypes = UsuarioEmpresaAction